<!-- mainIconMenu -->
<div class="mainIconMenu hp-cate">
    <ng-container *ngFor="let item of contentsPdtCates">
        <a (click)="goToShoppingMall(item)">
            <div><img [src]="urlWownet + '/' + item.filePath + item.fileName"></div>
            <p>{{ item.cateName }}</p>
        </a>
    </ng-container>
</div>
<!-- //mainIconMenu -->